<div class="container px-4 my-4">
  <div class="alert alert-info">
    <p>Reindirizzamento in corso...</p>
    <p>Si prega di attendere mentre verifichiamo il collegamento.</p>
  </div>
</div>
